export default __webpack_public_path__ + "static/media/gallery_01.d109c23e.jpg";